<template>
  <div class="payment-partners" ref="partnerSection">
    <div class="title-section">
      <h2 class="text-center">Our clients are backed by</h2>
    </div>

    <div class="partners-grid">
      <div
        v-for="(partner, index) in partners"
        :key="index"
        class="partner-item"
        :class="{ 'animate-partner': isVisible }"
        :style="{ animationDelay: isVisible ? `${index * 0.2}s` : '0s' }"
      >
        <img :src="partner.logo" :alt="partner.name" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const partnerSection = ref(null);
const isVisible = ref(false);

let observer = null;

onMounted(() => {
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          isVisible.value = true;
        } else {
          isVisible.value = false;
        }
      });
    },
    {
      threshold: 0.2,
    }
  );

  if (partnerSection.value) {
    observer.observe(partnerSection.value);
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

const partners = [
  {
    name: "MasterCard",
    logo: new URL("@/assets/imgsnew/page2-1.svg", import.meta.url).href,
  },
  {
    name: "Visa",
    logo: new URL("@/assets/imgsnew/page2-2.svg", import.meta.url).href,
  },
  {
    name: "Deca+",
    logo: new URL("@/assets/imgsnew/page2-3.svg", import.meta.url).href,
  },
  {
    name: "JCB",
    logo: new URL("@/assets/imgsnew/page2-4.svg", import.meta.url).href,
  },
  {
    name: "Partner 5",
    logo: new URL("@/assets/imgsnew/page2-5.svg", import.meta.url).href,
  },
  {
    name: "American Express",
    logo: new URL("@/assets/imgsnew/page2-6.svg", import.meta.url).href,
  },
];
</script>

<style scoped>
.payment-partners {
  padding: 30px 0;
  height: 160px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  background-color: #000;
  color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  overflow: hidden;
}

.title-section {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-section h2 {
  font-size: 1.5rem;
  font-weight: 500;
  margin: 0;
}

.partners-grid {
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 60px;
  height: 25px;
}

.partner-item {
  flex: 0 1 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
  opacity: 0;
}

.animate-partner {
  animation: fadeInSlideUp 0.6s ease forwards;
}

@keyframes fadeInSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.partner-item:hover {
  transform: scale(1.05) translateY(0);
}

.partner-item img {
  height: 25px;
  width: auto;
}

@media (max-width: 768px) {
  .payment-partners {
    height: 100px;
    padding: 10px 0;
    position: relative;
  }

  .title-section {
    margin-bottom: 15px;
    height: 20px;
  }

  .title-section h2 {
    font-size: 1.2rem;
  }

  .partners-grid {
    width: 100%;
    gap: 25px;
    overflow-x: auto;
    padding: 0 20px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    scroll-behavior: smooth;
    position: relative;
    max-height: 40px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
  }

  .partners-grid::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }

  .partner-item {
    flex: 0 0 auto;
    height: 25px;
    width: auto;
    display: inline-flex;
    animation: fadeInSlideRight 0.6s ease forwards;
    transform-origin: left center;
  }

  @keyframes fadeInSlideRight {
    from {
      opacity: 0;
      transform: translateX(10px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .partner-item img {
    height: 25px;
    width: auto;
    max-width: none;
  }

  .partners-grid::before,
  .partners-grid::after {
    content: "";
    flex: 0 0 0px;
  }

  .animate-partner {
    animation: fadeInSlideRight 0.6s ease forwards;
  }
}

/* 小屏幕手机 */
@media (max-width: 480px) {
  .payment-partners {
    padding: 10px 0;
    height: 90px;
  }

  .title-section {
    margin-bottom: 10px;
    height: 18px;
  }

  .title-section h2 {
    font-size: 1rem;
  }

  .partners-grid {
    gap: 20px;
    padding: 0 15px;
    max-height: 35px;
  }

  .partner-item {
    width: auto;
    height: 20px;
  }

  .partner-item img {
    height: 20px;
  }
}
</style>
